/**
 * Supimpa Salgados — Main JavaScript
 * Handles: mobile menu toggle, hero slider (Phase 3)
 */ /* ==========================================================================
   Mobile Menu Toggle
   ========================================================================== */ function initMobileMenu() {
    const toggle = document.querySelector('.menu-toggle');
    const nav = document.querySelector('.site-nav');
    if (!toggle || !nav) return;
    toggle.addEventListener('click', ()=>{
        const isOpen = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', String(!isOpen));
        nav.classList.toggle('is-open', !isOpen);
        // Update label for screen readers
        toggle.setAttribute('aria-label', isOpen ? "Abrir menu de navega\xe7\xe3o" : "Fechar menu de navega\xe7\xe3o");
    });
    // Close menu when clicking a nav link (mobile UX)
    nav.querySelectorAll('.nav-link').forEach((link)=>{
        link.addEventListener('click', ()=>{
            toggle.setAttribute('aria-expanded', 'false');
            nav.classList.remove('is-open');
        });
    });
    // Close menu on Escape key
    document.addEventListener('keydown', (e)=>{
        if (e.key === 'Escape' && nav.classList.contains('is-open')) {
            toggle.setAttribute('aria-expanded', 'false');
            nav.classList.remove('is-open');
            toggle.focus();
        }
    });
}
/* ==========================================================================
   Hero Slider (Phase 4)
   Lightweight JS to enhance CSS Scroll Snap with arrows, dots, and auto-play.
   ========================================================================== */ function initHeroSlider() {
    const track = document.getElementById('hero-track');
    const prevBtn = document.querySelector('.hero-prev');
    const nextBtn = document.querySelector('.hero-next');
    const dots = document.querySelectorAll('.hero-dot');
    const slides = document.querySelectorAll('.hero-slide');
    const sliderSection = document.querySelector('.hero-slider-section');
    if (!track || slides.length === 0) return;
    // Configuration
    const autoPlayInterval = 5000; // 5 seconds
    let autoPlayTimer;
    let isHoveredOrFocused = false;
    // Helper to scroll to a specific slide index
    const scrollToSlide = (index)=>{
        if (index < 0 || index >= slides.length) return;
        const slideWidth = slides[0].getBoundingClientRect().width;
        track.scrollTo({
            left: slideWidth * index,
            behavior: 'smooth'
        });
    };
    // Setup Arrows
    if (prevBtn) prevBtn.addEventListener('click', ()=>{
        track.scrollBy({
            left: -track.clientWidth,
            behavior: 'smooth'
        });
    });
    if (nextBtn) nextBtn.addEventListener('click', ()=>{
        // If at the end, loop back to start. Otherwise scroll next.
        const maxScroll = track.scrollWidth - track.clientWidth;
        if (track.scrollLeft >= maxScroll - 10) scrollToSlide(0);
        else track.scrollBy({
            left: track.clientWidth,
            behavior: 'smooth'
        });
    });
    // Setup Dots (Click to navigate)
    dots.forEach((dot, index)=>{
        dot.addEventListener('click', ()=>{
            scrollToSlide(index);
        });
    });
    // Intersection Observer to update active dot when swiping naturally
    const observerOptions = {
        root: track,
        threshold: 0.5 // Trigger when a slide is 50% visible
    };
    const slideObserver = new IntersectionObserver((entries)=>{
        entries.forEach((entry)=>{
            if (entry.isIntersecting) {
                const index = Array.from(slides).indexOf(entry.target);
                // Update dots UI
                dots.forEach((dot, i)=>{
                    const isActive = i === index;
                    dot.classList.toggle('is-active', isActive);
                    dot.setAttribute('aria-selected', String(isActive));
                });
            }
        });
    }, observerOptions);
    slides.forEach((slide)=>slideObserver.observe(slide));
    // Auto-play feature
    const startAutoPlay = ()=>{
        // Respect user's reduced motion preference
        const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (prefersReducedMotion) return;
        stopAutoPlay();
        autoPlayTimer = setInterval(()=>{
            if (!isHoveredOrFocused) {
                if (nextBtn) nextBtn.click();
            }
        }, autoPlayInterval);
    };
    const stopAutoPlay = ()=>{
        if (autoPlayTimer) clearInterval(autoPlayTimer);
    };
    // Pause on hover or keyboard focus for accessibility
    if (sliderSection) {
        sliderSection.addEventListener('mouseenter', ()=>isHoveredOrFocused = true);
        sliderSection.addEventListener('mouseleave', ()=>isHoveredOrFocused = false);
        sliderSection.addEventListener('focusin', ()=>isHoveredOrFocused = true);
        sliderSection.addEventListener('focusout', ()=>isHoveredOrFocused = false);
    }
    // Initialize auto-play
    startAutoPlay();
}
/* ==========================================================================
   Initialize
   ========================================================================== */ document.addEventListener('DOMContentLoaded', ()=>{
    initMobileMenu();
    initHeroSlider();
});

//# sourceMappingURL=contato.44be6387.js.map
